import React from 'react'

import { Card, CardHeading, CardContent } from '@components/layout/Card'

import { Grid } from '@UILibrary/Grid'
import { Text } from '@UILibrary/Text'

import FinancialHealthLineChart from '../shared/FinancialHealthLineChart'

import { Stat } from '../../../Shared/Stat'

interface ChartData {
  labels: string[]
  datasets: object
}

interface EmployeeSpendingProps {
  currentSpendingPercentage: number
  averageSpendingAmount: number
  benchmark: number
  benchmarkVariancePercentage: number
  scopeVariancePercentage: number
  timeframe: string
  averageIncome?: number
  chartData: ChartData
}

export const EmployeeSpending: React.FC<EmployeeSpendingProps> = (props) => {
  return (
    <div id="employee-spending">
      <Card>
        <CardHeading>
          <Text heading4a colour="secondary-main" as="h3" margin="none">
            How much of their income is your team spending every month?
          </Text>
          <Text body as="p" margin="none">
            A healthy income:spending ratio is considered to be below <strong>{props.benchmark}%</strong>.
          </Text>
        </CardHeading>
        <CardContent>
          <Text as="p" margin={{ bottom: 's' }}>
            Your team's average spend ratio is <strong>{props.currentSpendingPercentage}%</strong>, which is <strong>{props.currentSpendingPercentage < props.benchmark ? 'lower' : 'higher'}</strong> than the recommended maximum.
          </Text>
          <Grid cols="1-a" gap="m">
            <FinancialHealthLineChart
              height="medium"
              chartData={props.chartData}
              benchmark={props.benchmark}
            />
            <Stat percentage={props.scopeVariancePercentage} timeframe={props.timeframe} reverseCheck={true}/>
          </Grid>
          <Text bodySmall as="p" textAlign='center' margin='none'>
            (click legends to toggle on and off)
          </Text>
        </CardContent>
      </Card>
    </div>
  )
}
